import React from 'react'
import ProductCalculations from '../../../utils/product-calculations'
import PriceFormatter from '../../../utils/price-formatter'
import Config from '../../../config'
import OrderStore from '../../../stores/order-store'
import ProductStore from '../../../stores/product-store'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import EditorActions from '../../../actions/editor-actions'
import createReactClass from 'create-react-class'


/**
 * The product selector for batch toolbar
 */
var BatchProductSelector = createReactClass({


	handleProductSelect: function(event) {

		var productId = event.target.value.split('-')[0];
		if (productId !== "") {
			var width = event.target.value.split('-')[1];
			var product = ProductStore.getProductById(productId);
			var height = product.getHeight();
			EditorActions.batchProduct(productId, width, height);

			//Update warnings
			var batchItems = OrderStore.getBatchItems();
			for (var i = 0; i <batchItems.length; i++) {
				ProductCalculations.updateLowResAndCropWarnings(batchItems[i], width, height);
			}
		}
	},
	getCategoryLabel: function (prodCat) {
		if (prodCat.getLabelFromProductId) {
			var product = ProductStore.getProductById(prodCat.getLabelFromProductId);
			if (product) {
				return product.getLabel();
			}
		}
		return _(prodCat.label);
	},

	getCategoryProductList: function() {
		var productCategories = Config.ProductCategories,
			productCategoryLists = {},
			returnList = [];


		for(var c = 0; c < productCategories.length; c++) {
			var prodCat = productCategories[c];
			var catLabel = this.getCategoryLabel(prodCat);
			productCategoryLists[catLabel] = [];
			for(var i = 0; i < prodCat.products.length; i++) {
				var productId = prodCat.products[i],
					product = ProductStore.getProductById(productId);
				if (product) {
					if (Config.EditorModes[sessionStorage.getItem("editorMode")].indexOf(productId) >= 0 || productId.indexOf('_polaroid') > -1) {
						for(var width in product.options.printWidth) {
							var widthData = product.options.printWidth[width],
								productPrice = parseFloat(product.getBasePrice()) + parseFloat(widthData.price);
							var label = widthData.title;

							for (var l = label.length; l <= 27; l++) {
								label += "\u00a0";
							}
							label += PriceFormatter(productPrice);

							productCategoryLists[catLabel].push(
								<option value={productId + '-' + width} key={productId + '-' + width}>{label}</option>
							);
						}
					}
				}
			}
		}

		for (var categoryLabel in productCategoryLists) {
			if (productCategoryLists[categoryLabel].length > 0) {
				returnList.push(
					<optgroup label={categoryLabel} key={categoryLabel}>
						{productCategoryLists[categoryLabel]}
					</optgroup>
				);
			}

		}

		return returnList;
	},

	render: function() {
		var options = this.getCategoryProductList();

		return (
			<div className={this.props.className}>
				<select onChange={this.handleProductSelect}>
					<option value="">{this.props.label}</option>
					{options}
				</select>
			</div>
		);
	}
});

export default BatchProductSelector;
